"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("./index15.js");require("./index16.js");const a=require("@apollo/client");var e,n=a.gql(e||(e=t.default([`
  mutation cancelSeatRequest {
    cancelSeatRequest {
      success
    }
  }
`])));exports.CancelSeatRequestDocument=n;
